module.exports = __webpack_public_path__ + "img/deep-robot-logo.1e479d28.png";